export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_TOKEN (state, token) {
    state.access_token = token
  },
  ORGANISATIONID (state, organisation) {
    state.organisationid = organisation
  },
  orgRemarks (state, orgRemark) {
    state.orgRemarks = orgRemark
  },
  STARTDATE (state, startDate) {
    state.startDate = startDate
  },
  ENGLISHDATEENABLED (state, englishDate) {
    state.isEnglishDateEnabled = englishDate
  },
  ENDDATE (state, endDate) {
    state.endDate = endDate
  },
  TRANSACTIONDATE (state, transactionDate) {
    state.transactionDate = transactionDate
  },
  FYID (state, fyId) {
    state.fyId = fyId
  },
  FISCALYEAR (state, fiscalYear) {
    state.fiscalYear = fiscalYear
  },
  ENABLE2FA (state, enable2FA) {
    state.enable2FA = enable2FA
  },
  IRDACTIVE (state, organisationIRDActive) {
    state.organisationIRDActive = organisationIRDActive
  },
  IRDUSERNAME (state, irdUsername) {
    state.irdUsername = irdUsername
  },
  IRDPASSWORD (state, irdPassword) {
    state.irdPassword = irdPassword
  },
  EXPIRY (state, expiry) {
    state.expiry = expiry
  },
  MODULES(state, modules) {
    state.modules = modules
  },
  NEPALI_NEWDATE(state, nepaliDate) {
    state.nepaliNewDate = nepaliDate
  },
  SET_WAREHOUSE_DATA (state, warehouse) {
    state.warehouseData = warehouse
  },
  SET_COUNTER_DATA (state, counter) {
    state.counterData = counter
  },
  FYNAME (state, fyName) {
    state.fyName = fyName
  },
  ORGANISATIONAME(state, organisationName) {
    state.organisationName = organisationName
  },
  ORGANISATIONADDRESS(state, organisationAddress) {
    state.organisationAddress = organisationAddress
  },
  ORGANISATIONCONTACT(state, organisationContact) {
    state.organisationContact = organisationContact
  },
  ORGANISATIONLOGO(state, organisationLogo) {
    state.organisationLogo = organisationLogo
  },
  ORGANISATIONPANVATNO(state, organisationPanVatNo) {
    state.organisationPanVatNo = organisationPanVatNo
  },
  TAXTYPE(state, taxType) {
    state.taxType = taxType
  },
  ABLEPRINTREALTIME(state, ablePrintRealTime) {
    state.ablePrintRealTime = ablePrintRealTime
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js